import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const SURVEY_PROPERTIES = 'survey properties'
export const NAME = 'name'
export const LANGUAGE = 'language'
export const OWNER = 'owner'
export const SURVEY_ID = 'survey id'
export const SURVEY_TYPE = 'survey type'
export const LAST_UPDATE = 'last update'
export const CLOSE = 'close'

export default {
  [PORTUGUESE]: {
    [SURVEY_PROPERTIES]: 'Propriedades da Pesquisa',
    [NAME]: 'Nome',
    [LANGUAGE]: 'Idioma',
    [OWNER]: 'Proprietário',
    [SURVEY_ID]: 'Id da Pesquisa',
    [SURVEY_TYPE]: 'Tipo de Pesquisa',
    [LAST_UPDATE]: 'Última Atualização',
    [CLOSE]: 'Fechar',
  },

  [ENGLISH]: {
    [SURVEY_PROPERTIES]: 'Survey Properties',
    [NAME]: 'Name',
    [LANGUAGE]: 'Language',
    [OWNER]: 'Owner',
    [SURVEY_ID]: 'Survey Id',
    [SURVEY_TYPE]: 'Survey Type',
    [LAST_UPDATE]: 'Last Update',
    [CLOSE]: 'Close',
  },

  [SPANISH]: {
    [SURVEY_PROPERTIES]: 'Propiedades de la Encuesta',
    [NAME]: 'Nombre',
    [LANGUAGE]: 'Idioma',
    [OWNER]: 'Propietario',
    [SURVEY_ID]: 'Id de la Encuesta',
    [SURVEY_TYPE]: 'Tipo de Encuesta',
    [LAST_UPDATE]: 'Última Actualización',
    [CLOSE]: 'Cerrar',
  },
}
